module.exports = __webpack_public_path__ + "img/podcast.24b85bb8.png";